module.exports = __webpack_public_path__ + "static/trainmethod-176383cf9aca9a376309a90ad171ffc9.png";